import moment from 'moment';

export const shouldUpdateNote = (updatedAt: any) => {
  const lastUpdateDateFormated = moment(updatedAt).format('DD-MM-YYYYY');
  const currentDateDormated = moment().format('DD-MM-YYYYY');
  return lastUpdateDateFormated !== currentDateDormated;
};
